// extracted by mini-css-extract-plugin
export default {"editor":"style_editor__X46vu","editorOutline":"style_editorOutline__Fa+ii"};